import { render, staticRenderFns } from "./examen.vue?vue&type=template&id=e05dc924&scoped=true&"
import script from "./examen.vue?vue&type=script&lang=js&"
export * from "./examen.vue?vue&type=script&lang=js&"
import style0 from "./examen.vue?vue&type=style&index=0&id=e05dc924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05dc924",
  null
  
)

export default component.exports